
/* KILLIK Google Ads interactions, 19 Oct 2026.
   Ecommerce is owned by Google's app. These are zero-value secondary actions.
   No form values, names, email addresses or phone numbers are read or sent. */
(() => {
  'use strict';
  if (window.killikLeadTrackingInstalled) return;
  window.killikLeadTrackingInstalled = true;
  const labels = {
    function_enquiry: 'UbZBCI-v56EdEMTQxalD',
    newsletter_signup: 'd5E5CJKv56EdEMTQxalD',
    contact_click: '7U3RCJWv56EdEMTQxalD',
    booking_handoff: 'ubCyCMGxkJgcEMTQxalD'
  };
  const sent = new Set();
  const pending = [];
  function measure(name, key, method) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) { if (pending.length < 20) pending.push([name, key, method]); return; }
    if (!privacy.marketingAllowed() || !privacy.analyticsProcessingAllowed() || sent.has(key)) return;
    sent.add(key);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.dataLayer.push({ event: 'killik_' + name, contact_method: method || undefined });
    window.gtag('event', 'conversion', {
      send_to: 'AW-18072299588/' + labels[name],
      value: 0, currency: 'AUD', transport_type: 'beacon'
    });
  }
  document.addEventListener('killik:function-enquiry-sent', () => measure('function_enquiry', 'function_enquiry'));
  document.addEventListener('killik:booking-handoff', () => measure('booking_handoff', 'booking_handoff'));
  document.addEventListener('killik:sent', e => {
    const id = e.target && e.target.id;
    if (id === 'FooterSignup' || id === 'notifyForm') measure('newsletter_signup', 'signup_' + id);
  });
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    const method = href.startsWith('tel:') ? 'phone' : href.startsWith('mailto:') ? 'email' : null;
    if (method) measure('contact_click', 'contact_' + method, method);
  });
  labels.brunch_request = 'PWp1CPj756EdEMTQxalD';
  window.addEventListener('message', e => {
    if (e.origin !== 'https://3f9newvkri.zite.so') return;
    if (!Array.from(document.querySelectorAll('iframe')).some(frame => frame.contentWindow === e.source)) return;
    let data = e.data;
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (_) { return; } }
    if (!data || data.event !== 'killik_brunch_booking') return;
    measure('brunch_request', 'brunch_request');
  });
  function ready() {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return;
    const queue = pending.splice(0);
    queue.forEach(args => measure.apply(null, args));
    ['FooterSignup', 'notifyForm'].forEach(id => {
      const form = document.getElementById(id);
      const ok = form && form.querySelector('[data-form-ok]');
      if (ok && !ok.hidden) measure('newsletter_signup', 'signup_' + id);
    });
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
  }
  ready();
})();
/* KILLIK — send Shopify forms (bookings, mailing list) without leaving the page.
   Shopify answers a successful contact/customer post by redirecting to
   ?contact_posted=true or ?customer_posted=true. If its spam check wants a
   captcha (/challenge), we fall back to a normal page submit. */
(() => {
  'use strict';

  // Shopify adds ?contact_posted=true / ?customer_posted=true after a normal post; the
  // page has already read the result from the markup, so tidy the address bar.
  try {
    const u = new URL(location.href);
    if (u.searchParams.has('contact_posted') || u.searchParams.has('customer_posted')) {
      u.searchParams.delete('contact_posted'); u.searchParams.delete('customer_posted');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    }
  } catch (err) { /* old browser */ }

  // Shopify's documented hook for script-submitted forms: wait until its captcha
  // (hCaptcha) has put its token into the form before we send it. If the captcha
  // script isn't on the page (or is blocked), carry on after a short wait.
  window.killikCaptcha = function killikCaptcha(form) {
    return new Promise(resolve => {
      const cap = window.Shopify && window.Shopify.captcha;
      if (!cap || typeof cap.protect !== 'function') return resolve();
      let done = false;
      const finish = () => { if (!done) { done = true; resolve(); } };
      try { cap.protect(form, finish); } catch (err) { finish(); }
      setTimeout(finish, 5000);
    });
  };

  window.killikPost = async function killikPost(form) {
    await window.killikCaptcha(form);
    try {
      const res = await fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      });
      const url = res.url || '';
      if (/\/challenge/.test(url)) return { fallback: true };
      if (/(contact|customer)_posted=true/.test(url)) return { ok: true };
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const twin = form.id ? doc.getElementById(form.id) : null;
      if (twin) {
        if (twin.querySelector('[data-booking-posted], [data-notify-posted], [data-form-ok]:not([hidden])')) return { ok: true };
        const err = twin.querySelector('[data-form-error]');
        if (err && err.textContent.trim()) return { ok: false, error: err.textContent.trim() };
      }
      if (doc.querySelector('form[action*="challenge"], #g-recaptcha, .h-captcha')) return { fallback: true };
      return { ok: false, error: 'That didn’t go through. Please try again in a moment.' };
    } catch (err) {
      return { fallback: true };
    }
  };

  // Product options: keep the button and spec-sheet price in step with the chosen option
  const variantSelect = document.getElementById('ProductVariant');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const o = variantSelect.selectedOptions[0];
      if (!o) return;
      const add = document.querySelector('[data-add-price]');
      const spec = document.querySelector('[data-product-price]');
      if (add) add.textContent = o.dataset.price;
      if (spec) spec.textContent = o.dataset.priceFull;
    });
  }

  // Mailing-list forms: footer sign-up, coming-soon pop-up, coming-soon product page
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('js-ajax-form')) return;
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const btn = form.querySelector('[type="submit"]');
    const fields = form.querySelector('[data-form-fields]');
    const ok = form.querySelector('[data-form-ok]');
    const errEl = form.querySelector('[data-form-error]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    form.dispatchEvent(new CustomEvent('killik:sending', { bubbles: true }));
    const r = await window.killikPost(form);
    if (r.fallback) { form.dispatchEvent(new CustomEvent('killik:fallback', { bubbles: true })); form.submit(); return; }
    if (btn) { btn.disabled = false; btn.innerHTML = label; }
    if (r.ok) {
      if (fields) fields.hidden = true;
      if (ok) { ok.hidden = false; ok.setAttribute('tabindex', '-1'); ok.focus({ preventScroll: true }); }
      form.reset();
      form.dispatchEvent(new CustomEvent('killik:sent', { bubbles: true }));
    } else if (errEl) {
      errEl.textContent = r.error; errEl.hidden = false;
    }
  });
})();

/* KILLIK Google Ads interactions, 19 Oct 2026.
   Ecommerce is owned by Google's app. These are zero-value secondary actions.
   No form values, names, email addresses or phone numbers are read or sent. */
(() => {
  'use strict';
  if (window.killikLeadTrackingInstalled) return;
  window.killikLeadTrackingInstalled = true;
  const labels = {
    function_enquiry: 'UbZBCI-v56EdEMTQxalD',
    newsletter_signup: 'd5E5CJKv56EdEMTQxalD',
    contact_click: '7U3RCJWv56EdEMTQxalD',
    booking_handoff: 'ubCyCMGxkJgcEMTQxalD'
  };
  const sent = new Set();
  const pending = [];
  function measure(name, key, method) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) { if (pending.length < 20) pending.push([name, key, method]); return; }
    if (!privacy.marketingAllowed() || !privacy.analyticsProcessingAllowed() || sent.has(key)) return;
    sent.add(key);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.dataLayer.push({ event: 'killik_' + name, contact_method: method || undefined });
    window.gtag('event', 'conversion', {
      send_to: 'AW-18072299588/' + labels[name],
      value: 0, currency: 'AUD', transport_type: 'beacon'
    });
  }
  document.addEventListener('killik:function-enquiry-sent', () => measure('function_enquiry', 'function_enquiry'));
  document.addEventListener('killik:booking-handoff', () => measure('booking_handoff', 'booking_handoff'));
  document.addEventListener('killik:sent', e => {
    const id = e.target && e.target.id;
    if (id === 'FooterSignup' || id === 'notifyForm') measure('newsletter_signup', 'signup_' + id);
  });
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    const method = href.startsWith('tel:') ? 'phone' : href.startsWith('mailto:') ? 'email' : null;
    if (method) measure('contact_click', 'contact_' + method, method);
  });
  function ready() {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return;
    const queue = pending.splice(0);
    queue.forEach(args => measure.apply(null, args));
    ['FooterSignup', 'notifyForm'].forEach(id => {
      const form = document.getElementById(id);
      const ok = form && form.querySelector('[data-form-ok]');
      if (ok && !ok.hidden) measure('newsletter_signup', 'signup_' + id);
    });
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
  }
  ready();
})();
